<template>
    <div class="cert-status" id="cashOutStatus" v-cloak>
        <div class="cert-status-content">
            <div class="cert-status-icon-success"></div>
            <p class="cert-status-title">{{phone}}</p>
            <p class="cert-status-title">登陆成功</p>
        </div>
    </div>
</template>

<script>
    import {
            Button
    } from 'vant';
    export default {
        name: 'loginSuccess',
        components: {
            [Button.name]: Button,
        },
        data:function () {
            return {
                phone:this.$route.query.phone.substring(0,3)+'****'+this.$route.query.phone.substring(7)
            }
        },
        mounted: function(){
            document.title = "登录成功";
            setTimeout(function () {
                rbLink({ 
                    "name":'index'
                },'replace');
            },1000)
        },
        methods:{

        }
    }
</script>


// WEBPACK FOOTER //
// loginSuccess.vue?69b2f0dc